import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="asset-search"
export default class extends Controller {
  static targets = ["input"]
  static values = { selectedId: Number }

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value
      const url = `/admin/ai_tutors/search_assets?query=${encodeURIComponent(query)}&selected_id=${this.selectedIdValue || ''}`

      fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        }
      })
        .then(response => {
          if (!response.ok) throw new Error(`Asset search failed (${response.status})`)
          return response.text()
        })
        .then(html => {
          // A slower response for an earlier query must not overwrite a newer one.
          if (query !== this.inputTarget.value) return
          Turbo.renderStreamMessage(html)
        })
        .catch(error => {
          console.error(error)
          if (query !== this.inputTarget.value) return
          this.showError()
        })
    }, 300)
  }

  // Replace the list rather than leaving stale rows that look like results.
  showError() {
    const results = document.getElementById("asset_search_results")
    if (!results) return

    results.innerHTML = `
      <div class="alert alert-danger mt-2 mb-0">
        <i class="bi bi-exclamation-triangle"></i> The search failed. Try again, or reload the page.
      </div>`
  }
}
